import { IonText } from '@ionic/react';
import { FullPost, getReplyTitle } from 'model';
import { Fragment, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useGetPollResponseCountQuery } from '../api/PollResponseAPI.js';
import { useEngagementLevel } from '../hooks/useEngagementLevel.js';
import { pluralize } from '../util/pluralize.js';
import styles from './StatsBar.module.css';

export type StatsBarProps = {
	post: FullPost;
	hideEmptyComments?: boolean;
};

export function StatsBar({ post, hideEmptyComments }: StatsBarProps) {
	const { totalComments = 0 } = post;
	const readCount = post.engagement.readCount;
	const likeCount = post.engagement.likeCount;
	const showEngagement = useEngagementLevel() !== 'none';
	const { data: pollData } = useGetPollResponseCountQuery(post._id, { skip: post.postType !== 'poll' });

	const pollCount = useMemo(() => {
		if (post.postType === 'poll') {
			return pollData?.total;
		}
		return undefined;
	}, [post, pollData]);

	const elements = [];

	if (!hideEmptyComments || totalComments > 0) {
		elements.push(
			<IonText>
				{totalComments <= 0 ? '' : totalComments}&nbsp;
				{totalComments <= 0
					? pluralize(2, getReplyTitle(post.postType)) // Use plural version when totalComments is <= 0
					: pluralize(totalComments, getReplyTitle(post.postType))}
			</IonText>
		);
	}

	if (pollCount && pollCount > 0) {
		elements.push(
			<IonText>
				{pollCount} {pluralize(pollCount, 'vote')}
			</IonText>
		);
	}

	if (showEngagement && Number(likeCount) > 0) {
		elements.push(
			<IonText>
				{likeCount} {pluralize(likeCount, 'like')}
			</IonText>
		);
	}

	if (showEngagement && readCount > 0) {
		elements.push(
			<IonText>
				{readCount} {pluralize(readCount, 'view')}
			</IonText>
		);
	}
	return (
		<>
			{elements.length > 0 ? (
				<NavLink to={`/main/latest/post/show/${post._id}`} className="nounderline">
					<div className={styles.engagementStatsContainer}>
						<span className={styles.ReadCount}>
							<>
								{elements.map((element, index) => (
									<Fragment key={index}>
										{index !== 0 && <IonText>•</IonText>}
										{element}
									</Fragment>
								))}
							</>
						</span>
					</div>
				</NavLink>
			) : (
				<></>
			)}
		</>
	);
}
